import { useDefaultAvatar } from "./components/ProfileSummary/index.jsx";
import { useMenuNotifications } from "./hooks/useMenuNotifications.js";
import React from "react";
import { AppRouterProvider, AppRoutes } from "./routes/config";
import { Sidebar } from "./components/Sidebar";
import { TopbarMini } from "./components/TopbarMini";
import { StudyTimeWidget } from "./components/StudyTimeWidget";
import { APP_SHELL_STYLES } from "./styles";
import { swipeHandlers } from "./utils/swipeHandlers";
import { useAppShellState } from "./hooks/useAppShellState";
function AppContent() {
  const value = useAppShellState();
  const adminAba = value.adminAba;
  const adminLogged = value.adminLogged;
  const agPendHoje = value.agPendHoje;
  const agendamentos = value.agendamentos;
  const canGoBack = value.canGoBack;
  const ctx = value.ctx;
  const currentStudent = value.currentStudent;
  const desPend = value.desPend;
  const flash = value.flash;
  const goBack = value.goBack;
  const logado = value.logado;
  const questPend = value.questPend;
  const resgPend = value.resgPend;
  const setAdminAba = value.setAdminAba;
  const setSideOpen = value.setSideOpen;
  const sideOpen = value.sideOpen;
  const view = value.view;
  useDefaultAvatar(currentStudent, !adminLogged, ctx.setStudents);
  const menuNotifications = useMenuNotifications(
    currentStudent,
    adminLogged,
    view,
  );
  return (
    <div className={"r"}>
      <style>{APP_SHELL_STYLES}</style>
      {logado && (
        <React.Fragment>
          <Sidebar
            {...{
              ...ctx,
              view,
              questPend,
              resgPend,
              desPend,
              agPendHoje,
              open: sideOpen,
              onClose: () => setSideOpen(false),
              adminAba,
              setAdminAba,
              menuDots: menuNotifications,
            }}
          />
          {sideOpen && (
            <div className={"sb-overlay"} onClick={() => setSideOpen(false)} />
          )}
        </React.Fragment>
      )}
      <div
        {...{
          className: logado
            ? "main-shifted" + (sideOpen ? " sidebar-expanded" : "")
            : "",
          ...(logado ? swipeHandlers(goBack) : {}),
          children: [
            logado && (
              <TopbarMini
                key="topbar"
                view={view}
                goBack={goBack}
                currentStudent={currentStudent}
                adminLogged={adminLogged}
                onMenuClick={() => setSideOpen((resultado) => !resultado)}
                canGoBack={canGoBack}
              />
            ),
            currentStudent && !adminLogged && (
              <StudyTimeWidget
                key="study-time"
                currentStudent={currentStudent}
              />
            ),
            flash && (
              <div
                key="flash"
                style={{
                  position: "fixed",
                  top: logado ? 60 : 12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "min(560px, calc(100vw - 28px))",
                  zIndex: 1e4,
                  pointerEvents: "none",
                }}
              >
                <div
                  className={"fl2 ".concat(
                    "ok" === flash.tipo
                      ? "ok"
                      : "er" === flash.tipo
                        ? "er"
                        : "wa" === flash.tipo
                          ? "wa"
                          : "in",
                  )}
                  style={{
                    marginBottom: 0,
                    boxShadow: "0 10px 28px rgba(0,0,0,0.18)",
                  }}
                >
                  {flash.msg}
                </div>
              </div>
            ),
            <AppRoutes
              key="routes"
              ctx={ctx}
              currentStudent={currentStudent}
              adminLogged={adminLogged}
              agendamentos={agendamentos}
            />,
            <footer
              key="footer"
              style={{
                marginTop: 32,
                padding: "14px",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 800,
                  color: "rgba(255,255,255,0.65)",
                }}
              >
                {"Daniel Marlon - Reforço Escolar"}
              </div>
              <div
                style={{
                  fontSize: 10,
                  color: "rgba(255,255,255,0.3)",
                  marginTop: 6,
                }}
              >
                {"v5"}
              </div>
            </footer>,
          ],
        }}
      />
    </div>
  );
}
export default function AppContainer() {
  return (
    <AppRouterProvider>
      <AppContent />
    </AppRouterProvider>
  );
}
